<template>
  <div class="LoadProgress layout-container text-center">
    <p class="type-xs desk:type-sm mb-24">
      {{ $t(text, {
        current: current,
        total: total
      }) }}
    </p>
    <div
      class="w-260 h-4 mx-auto bg-light mb-20 desk:mb-24"
    >
      <div
        class="bg-mintPrimary h-4"
        :style="{
          width: `${current / total * 100}%`,
        }"
      />
    </div>
    <button
      v-if="current < total"
      class="btn inline-block uppercase"
      :class="{
        loading
      }"
      @click="$emit('loadMore')"
    >
      {{ $t(buttonText) }}
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  current: number,
  total: number,
  text: string,
  buttonText?: string,
  loading?: boolean,
}
withDefaults(defineProps<Props>(), {
  loading: false,
  buttonText: 'filter.loadmore',
});

defineEmits(['loadMore']);
</script>

<style scoped lang="postcss">
</style>
